const machine = {
    state: {
        isMobile:false,
        menuList:[]
    },
    mutations: {
        set_isMobile(state, boolean) {
            state.isMobile = boolean;
        },
        set_menuList(state,value){
            state.menuList = value;
        }
    },
    actions: {
        setIsMobile({commit}, boolean) {
            commit('set_isMobile', boolean);
        },
        setMenuList({commit},value){
            commit("set_menuList",value);
            localStorage.setItem("m",JSON.stringify(value));
        }
    }
};
export default machine;
